import { Banner, Faq, FeaturesOfWebApp, IndustriesWeEmpower, RefiningContent, TypesOfWebApplications, WhyChooseCustomWebAppDevelopment } from "./components"

 function WebAppDevelopment(){
    return(
  <div className="  space-y-20 md:space-y-36 mb-20 md:mb-32">
     <Banner/>
     <TypesOfWebApplications/>
     <FeaturesOfWebApp/>
     <WhyChooseCustomWebAppDevelopment/>
     <IndustriesWeEmpower/>
     <RefiningContent/>
     <Faq/>
     </div>
    )
 }

 export default WebAppDevelopment;